import mixpanel from "mixpanel-browser"

export interface MixPanelGlobalAuthenticatedProps {
  studentRole: string
  country: string
  yearStudy: string
  studyArea: string
  activePlan: string
}

export function trackAuthenticatedUsers(props: MixPanelGlobalAuthenticatedProps) {
  mixpanel.register({
    isAuthenticated: true,
    ...props,
  })
}
